import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BrokeNotificationMutationKeys } from '../../../keys'
import {
	CreateBrokeNotificationRequest,
	CreateBrokeNotificationResponse,
} from '../../../type'
import { createBrokeNotification } from '../../services'

interface UseMutationCreateBrokeNotificationProps {
	payload: CreateBrokeNotificationRequest
}

export default function useMutationCreateBrokeNotification(
	props?: UseBaseMutationOptions<
		CreateBrokeNotificationResponse,
		UseMutationCreateBrokeNotificationProps
	>,
) {
	return useMutation({
		mutationKey: [BrokeNotificationMutationKeys.CreateBrokeNotification],
		mutationFn: (params) => createBrokeNotification(params.payload),
		...props,
	})
}
